import './nav-bag.scss';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from '@sola/ark-core/atoms/link/link.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { useCart } from '@sola/cart-sdk/store.js';
import { getPublicConfig } from '@sola/config/lib/getters.js';

type NavBagProps = {
  cartCount?: number;
};

export const NavBag: React.FC<NavBagProps> = ({ cartCount }) => {
  const { t } = useTranslation(['priority']);
  const {
    actions: { getCart },
    cart,
    isReady: cartIsReady,
  } = useCart('actions', 'cart', 'isReady');
  const { NEXT_PUBLIC_BASE_URL_CHECKOUT } = getPublicConfig();

  useEffect(() => {
    getCart();
  }, [cart?.items.length, getCart]);

  const count =
    cartCount ||
    (cartIsReady && cart?.items.length !== 0 && cart?.items.length);

  const displayCount = count && count > 10 ? '9+' : count;

  return (
    <Link
      className="NavBag flex p-comfy-xs relative"
      href={cart?.checkoutUrl || NEXT_PUBLIC_BASE_URL_CHECKOUT}
      title={t('header.cart')}
      aria-label={t('header.cart')}
    >
      <ArkIcon iconName="shopping-bag-02" className="NavBag__icon" />
      {displayCount && (
        <span className="NavBag__count label-sm label-potent flex justify-center items-center aspect-ratio-1 absolute">
          {displayCount}
        </span>
      )}
    </Link>
  );
};
